import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { addAppraisal, getMyKPIs } from "../../utils/helper";
import { alertSuccess, alertError } from "../../utils/alerts";
import { months }  from '../../utils/dataFile';
import moment from "moment";
import Loader from "../../utils/Loader";

const INIT_STATE = {
    appraisal_cycle: "",
    month: "",
    year:"",
    date:"",
    corefunctions: [],
    corevalues: [
        {type: "Teamwork", label: "Ability to work with team members, share information and render support on projects", weighting: "0", selfscore:"" },
        {type: "Responsiveness", label: "Demonstrates proactiveness, initiative and sensitivity in responding to and dealing with issues", weighting: "0", selfscore:""},
        {type: "Innovation", label: "Contribution to renewing existing processes", weighting: "0", selfscore:""},
        {type: "Integrity", label: "Consistent display of Sincerity and honesty", weighting: "0", selfscore:""},
        {type: "Quality", label: "The quality of work output", weighting: "0", selfscore:""},
    ],
    behavioural: [
        {type: "Minimal Supervision", label: "Ability to perform on the job especially with respect to familiar work with minimal supervision", weighting: "0", selfscore:""},
        {type: "Punctuality and Attendance", label: "Attendance and punctuality at meetings and developmental sessions", weighting: "0", selfscore:"" },
        {type: "Communication", label: "Has good written and oral communication and listening skills. Ability to share information accurately.", weighting: "0", selfscore:""},
        {type: "Team Management and Leadership Skills", label: "Ensure overall coordination and supervision of the team", weighting: "0", selfscore:"" },
    ],
};


export default function NewAppraisal() {
    const [state, setState] = useState(INIT_STATE);
    const [kpis, setKPIs] = useState([]);
    const [cfSum, setCfSum] = useState(0);
    const [loading, setLoading] = useState(true);
    const [date] = useState(new Date());

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    useEffect(() => {
        setLoading(true);
        getMyKPIs()
            .then((res) => {
                if(res.data.success){
                    setKPIs(res.data.data);
                }
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            })
            .catch((err) => {
                alertError(err.response?.data?.error);
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            });
    }, []);
    
    useEffect(() => {
        const sum = kpis.reduce((acc, currentValue) => acc + currentValue.weighting, 0);
        const newArray = kpis.map(({ _id, kpd, kpi, weighting }) => ({ kpd:kpd._id, kpdName:kpd.kpd, kpi: _id, type: kpi, weighting, sum }));
        setCfSum(sum)

        setState((prev) => ({
            ...prev,
            year: (date && moment(date).format("YYYY")) || "",
            date: (date && moment(date).format("DD/MM/YYYY")) || "",
            month: (date && moment(date).format("MMMM")) || "",
            corefunctions: (newArray && newArray) || [],
        }));

        
    }, [date, kpis]);

    const handleCoreFunctionChange = (i) => (e) => {
        e.persist();
        const newCoreFunctions = state.corefunctions.map((item, index) => {
            if (i !== index) {
                return item;
            }
            return {
                ...item,
                [e.target.name]: e.target.value,
            };
        });
        setState((prev) => ({
            ...prev,
            corefunctions: newCoreFunctions,
        }));
    };

    const handleBehaviourChange = (i) => (e) => {
        e.persist();
        const newBehaviour = state.behavioural.map((item, index) => {
            if (i !== index) {
                return item;
            }
            return {
                ...item,
                [e.target.name]: e.target.value,
            };
        });
        setState((prev) => ({
            ...prev,
            behavioural: newBehaviour,
        }));
    };

    const handleCoreValuesChange = (i) => (e) => {
        e.persist();
        const newCore = state.corevalues.map((item, index) => {
            if (i !== index) {
                return item;
            }
            return {
                ...item,
                [e.target.name]: e.target.value,
            };
        });
        setState((prev) => ({
            ...prev,
            corevalues: newCore,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const newArray = state.corefunctions.map(({ _id, kpd, kpi, weighting }) => ({ kpd:kpd._id, kpi: _id, type: kpi, weighting }));
        const data = { ...state, corefunctions: newArray }

        if(data.employee && data.team && data.kpd && data.weighting){
            setLoading(true);
            addAppraisal(state)
            .then((res) => {
                if(res.data.success){
                    alertSuccess(res.data.message)
                } else {
                    alertError(res.data.message)
                }
                setLoading(false);
            })
            .catch((err) => {
                alertError(err.response?.data?.error);
                setLoading(false);
            });
        }
    };
    
    return (
        <>
            <h1 className="dash-title"><Link to="/performance/appraisals" style={{color: '#454545'}}><i className="fa fa-arrow-left"></i> Go Back</Link></h1>

            <div className="row dash-row">
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">New Appraisal</div>
                        </div>
                        <div className="card-body">
                            {(!loading && kpis && kpis) ? <>
                            <form method="post" encType="multipart/form-data" onSubmit={handleSubmit}>
                                {(kpis && kpis.length > 0) ? <>
                                
                                    <div className="row">
                                        <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                            <label className="control-label">Year: <span>*</span></label>
                                            <input name="year" type="text" placeholder="Year" className="form-control" required 
                                            onChange={handleChange} defaultValue={state.year} disabled />
                                        </div>
                                        <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                            <label className="control-label">Month: <span>*</span></label>
                                            <select className="form-control form-select" name="month" id="month" required  
                                            onChange={handleChange} defaultValue={state.month}>
                                                <option value=''>Month</option>
                                                {months && months.map((month, i) => (
                                                    <option key={i} value={month.month}>{month.month}</option>
                                                ))}
                                            </select>
                                        </div>
                                        
                                        <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                            <label className="control-label">Appraisal Cycle: <span>*</span></label>
                                            <select className="form-control form-select" name="appraisal_cycle" id="appraisal_cycle" required  
                                            onChange={handleChange} defaultValue={state.appraisal_cycle}>
                                                <option value=''>Select Cycle</option>
                                                <option value="monthly">Monthly</option>
                                                <option value="annually">Annually</option>
                                            </select>
                                        </div>
                                    </div>

                                    <h4 className="bg-title mt-3 mb-0 p-3 text-center">SECTION A: CORE FUNCTIONS</h4>
                                    
                                    <div className="my_profile">
                                        {state.corefunctions && state.corefunctions ? 
                                            <div className="table-responsive">
                                                <table className="table text-left text-caps table-bordered" id="myTable">
                                                    <thead>
                                                        <tr>
                                                            <th style={{width: '30%'}}>Key Performance Deliverable (KPD)</th>
                                                            <th style={{width: '40%'}}>KPI / Description</th>
                                                            <th style={{width: '10%'}}>Weightage</th>
                                                            <th style={{width: '20%'}}>Percentage achieved (Self Score)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {state.corefunctions && state.corefunctions.map((row, index) => 
                                                            <tr key={index}>
                                                                <td>{row?.kpdName && row?.kpdName}</td>
                                                                <td>{row?.type && row?.type}</td>
                                                                <td>{row?.weighting && row?.weighting}</td>
                                                                <td><input type="number" placeholder="Self Score" className="form-control" 
                                                                    onChange={handleCoreFunctionChange(index)}
                                                                    max={row?.weighting}
                                                                    min={0}
                                                                /></td>
                                                            </tr>
                                                        )}
                                                        <tr>
                                                            <td colSpan={2} align="right">Total:</td>
                                                            <td>{cfSum && cfSum}</td>
                                                            <td></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        : null }
                                    </div>

                                    <h4 className="bg-title mt-3 mb-0 p-3 text-center">SECTION B: BEHAVIOURAL</h4>
                                    
                                    <div className="my_profile">
                                        {state.behavioural && state.behavioural ? 
                                            <div className="table-responsive">
                                                <table className="table text-left text-caps table-bordered" id="myTable">
                                                    <thead>
                                                        <tr>
                                                            <th style={{width: '30%'}}>Personal Attributes</th>
                                                            <th style={{width: '40%'}}>Key Indicators / Description</th>
                                                            <th style={{width: '10%'}}>Weightage</th>
                                                            <th style={{width: '20%'}}>Percentage achieved (Self Score)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {state.behavioural && state.behavioural.map((row, index) => 
                                                            <tr key={index}>
                                                                <td>{row?.type && row?.type}</td>
                                                                <td>{row?.label && row?.label}</td>
                                                                <td>{row?.weighting && row?.weighting}</td>
                                                                <td><input type="text" placeholder="Self Score" className="form-control" 
                                                                    onChange={handleBehaviourChange(index)}
                                                                    max={row?.weighting}
                                                                /></td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        : null }
                                    </div>


                                    <h4 className="bg-title mt-3 mb-0 p-3 text-center">SECTION C: CORE VALUES</h4>
                                    
                                    <div className="my_profile">
                                        {state.corevalues && state.corevalues ? 
                                            <div className="table-responsive">
                                                <table className="table text-left text-caps table-bordered" id="myTable">
                                                    <thead>
                                                        <tr>
                                                            <th style={{width: '30%'}}>Personal Attributes</th>
                                                            <th style={{width: '40%'}}>Key Indicators / Description</th>
                                                            <th style={{width: '10%'}}>Weightage</th>
                                                            <th style={{width: '20%'}}>Percentage achieved (Self Score)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {state.corevalues && state.corevalues.map((row, index) => 
                                                            <tr key={index}>
                                                                <td>{row?.type && row?.type}</td>
                                                                <td>{row?.label && row?.label}</td>
                                                                <td>{row?.weighting && row?.weighting}</td>
                                                                <td><input type="text" placeholder="Self Score" className="form-control" 
                                                                    onChange={handleCoreValuesChange(index)}
                                                                    max={row?.weighting}
                                                                /></td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        : null }
                                    </div>


                                    <div className="row form-group">
                                        <div className="col-md-12 col-sm-12 mt-3 text-center">
                                            <button 
                                                type="submit" 
                                                disabled={loading}
                                                className="btn btn-primary" 
                                                onClick={() => handleSubmit}
                                            >
                                                CREATE APPRAISAL
                                            </button>
                                        </div>
                                    </div>
                                </> : 
                                <div className="alert alert-danger myerror d-block">
                                    Your KPI has not been uploaded yet. You will be able to start your appraisal  after PSM uploads your KPIs.
                                </div>}

                            </form>
                            </> : <Loader /> }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
